import React, { useState, useEffect } from "react";
import { Admin, Resource, CustomRoutes  } from "react-admin";
import { Route } from "react-router";
import Dashboard from "./Dashboard/Dashboard";
import { ChannelList, ChannelCreate, ChannelEdit } from "./Channel/ChannelList";
import { PartnerList, PartnerCreate, PartnerEdit } from "./Partner/PartnerList";
import { BundleList, BundleCreate, BundleEdit } from "./Bundle/BundleList";
import {
    CampaignList,
    CampaignCreate,
    CampaignEdit,
} from "./Campaign/CampaignList";
import { CodeList, CodeCreate, CodeShow } from "./Code/CodeList";
import { CodeConsumptionList } from "./CodeConsumption/CodeConsumption";
import { UserList, UserCreate, UserEdit } from "./User/UserList";
import graphQLDataProvider from "./Providers/dataProvider";
import PersonIcon from "@mui/icons-material/Person";
import BarChartIcon from "@mui/icons-material/BarChart";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import SourceIcon from "@mui/icons-material/Source";
import CampaignIcon from "@mui/icons-material/Campaign";
import authProvider from "./Providers/authProvider.js";
import MyLogin from "./Layout/MyLogin";
import MyLayout from "./Layout/MyLayout";
import MyLogoutButton from "./Layout/MyLogout";
import ChangePasswordView from "./Components/ChangePasswordView";

import { darkTheme } from "./Layout/Theme";

const App = () => {
    const [dataProvider, setDataProvider] = useState(null);

    useEffect(() => {
        graphQLDataProvider().then((graphQlDataProvider) =>
            setDataProvider(() => graphQlDataProvider)
        );
    }, []);

    if (!dataProvider) {
        return (
            <div className="loader-container">
                <div className="loader">Loading...</div>
            </div>
        );
    }

    return (
        <Admin
            theme={darkTheme}
            layout={MyLayout}
            loginPage={MyLogin}
            logoutButton={MyLogoutButton}
            dataProvider={dataProvider}
            authProvider={authProvider}
            dashboard={Dashboard}
        >
             <CustomRoutes>
                <Route path="/changepassword" element={<ChangePasswordView />} />
            </CustomRoutes>
            {(permissions) => (
                <>
                    <Resource
                        name="Channel"
                        list={ChannelList}
                        create={permissions === "ADMIN" ? ChannelCreate: null}
                        edit={permissions === "ADMIN" ?  ChannelEdit: null}
                        icon={BarChartIcon}
                    />
                    <Resource
                        name="Partner"
                        list={permissions === "ADMIN" ?  PartnerList: null}
                        create={permissions === "ADMIN" ? PartnerCreate: null}
                        edit={permissions === "ADMIN" ? PartnerEdit: null}
                        icon={SupervisedUserCircleIcon}
                    />
                    <Resource
                        name="Bundle"
                        list={BundleList}
                        create={permissions === "ADMIN" ? BundleCreate: null}
                        edit={permissions === "ADMIN" ? BundleEdit: null}
                    />
                    <Resource
                        name="Campaign"
                        list={CampaignList}
                        create={CampaignCreate}
                        edit={CampaignEdit}
                        icon={CampaignIcon}
                    />
                    <Resource
                        name="Code"
                        list={CodeList}
                        create={permissions === "ADMIN" ? CodeCreate: null}
                        show={CodeShow}
                        icon={SourceIcon}
                    />
                    <Resource
                        name="CodeConsumption"
                        options={{ label: "Consumed Codes" }}
                        list={CodeConsumptionList}
                        icon={SourceIcon}
                    />
                    <Resource
                        name="User"
                        list={permissions === "ADMIN" ? UserList: null}
                        create={permissions === "ADMIN" ? UserCreate: null}
                        edit={permissions === "ADMIN" ? UserEdit: null}
                        icon={PersonIcon}
                    />
                </>
            )}
        </Admin>
    );
};

export default App;
